import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { BUSINESS } from "../config";

export const CtaBand = ({ title = "Ready to transform your floors?", text = "Send us your measurements and photos for a clear, written flooring installation quote — free across Melbourne." }) => (
  <section className="bg-[#4A3018]" data-testid="cta-band">
    <div className="max-w-7xl mx-auto px-6 py-20 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
      <div>
        <h2 className="text-3xl sm:text-4xl tracking-tight font-semibold text-white">{title}</h2>
        <p className="mt-3 text-base text-white/70 max-w-xl leading-relaxed">{text}</p>
      </div>
      <Link
        to="/get-a-free-quote"
        className="inline-flex items-center gap-2 rounded-full bg-[#C87A38] px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-[#A6632B] focus:outline-none focus:ring-2 focus:ring-white shrink-0"
        data-testid="cta-band-quote-button"
      >
        Get a Free Quote <ArrowRight className="w-4 h-4" />
      </Link>
    </div>
  </section>
);

export const offerNote =
  "Final pricing depends on the floor area, property condition, subfloor preparation, colour selection and job location.";
export { BUSINESS };
